export default __webpack_public_path__ + "static/media/Session.6e63c44d.jpg";